interface DeviceContext {
  browser: string;
  deviceType: "mobile" | "desktop";
}

const getBrowser = (ua: string): string => {
  // Order matters: Edge/Opera/Samsung UAs also contain "Chrome"/"Safari".
  if (/Edg\//.test(ua)) return "Edge";
  if (/OPR\/|Opera/.test(ua)) return "Opera";
  if (/SamsungBrowser/.test(ua)) return "Samsung Internet";
  if (/Firefox\//.test(ua)) return "Firefox";
  if (/Chrome\//.test(ua)) return "Chrome";
  if (/Safari\//.test(ua)) return "Safari";
  return "Unknown";
};

const getDeviceType = (ua: string): "mobile" | "desktop" => {
  if (/Mobi|Android|iPhone|iPod/i.test(ua)) return "mobile";
  // iPadOS 13+ reports as "Macintosh"; disambiguate via touch points.
  if (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1) return "mobile";
  return "desktop";
};

/**
 * Best-effort client context parsed from the user-agent (browser, device type).
 * Values are approximate by design — the web platform doesn't expose the exact
 * device model.
 */
export const getDeviceContext = (): DeviceContext => {
  if (typeof navigator === "undefined")
    return { browser: "Unknown", deviceType: "desktop" };

  const ua = navigator.userAgent;
  return {
    browser: getBrowser(ua),
    deviceType: getDeviceType(ua),
  };
};
